// IMPORT:
var THREE = require("three");
var UTILS = require(/*! ./utils.js */"./utils.js");
var GEOS = require(/*! ./geos.js */"./geos.js");
var tmpVector = new THREE.Vector3();

// TRAILS:
var trailGeo = GEOS.generateCube(null, 1, 1, 1, {});
function Trail(RENDER) {
  this.mesh = new THREE.Mesh(trailGeo);

  // INIT:
  this.init = function (parent) {
    this.dst = parent.dst;
    this.spd = parent.spd;
    this.xS = parent.xS;
    this.zS = parent.zS;
    this.yS = parent.yS;
    this.scale = 0.45;
    this.len = 0;
    this.mesh.material = RENDER.getMat("default", {
      mat: THREE.MeshBasicMaterial,
      color: 0xededed,
      transparent: true,
      opacity: 0.21
    });
    var x = parent.mesh.position.x;
    var y = parent.mesh.position.y;
    var z = parent.mesh.position.z;
    RENDER.moveMesh(this.mesh, x, y, z);
    this.mesh.lookAt(x + this.xS, y + this.yS, z + this.zS);
    this.mesh.rotateX(Math.PI / 2);
    RENDER.scaleMesh(this.mesh, this.scale, this.len, this.scale);
    this.mesh.visible = true;
  };

  // UPDATE:
  this.update = function (delta) {
    if (this.mesh.visible) {
      if (this.len < this.dst) {
        this.len += this.spd * delta;
        if (this.len >= this.dst) {
          this.len = this.dst;
        }
      }
      this.scale -= 0.00036 * delta;
      RENDER.scaleMesh(this.mesh, this.scale, this.len, this.scale);
      if (this.scale <= 0) {
        this.scale = 0;
        this.mesh.visible = false;
      }
    }
  };
} // EXPLOSION OBJECT:
function ExplosionManager() {
  THREE.Object3D.call(this);
  this.largeSpawnCount = 8;
  this.smallSpawnCount = 15;
  this.emissiveness = 0.55;
  this.velocityDamping = 3;
  this.lifeSpeedMin = 2.2;
  this.lifeSpeedRange = 3;
  var geometry = new THREE.Geometry({
    dynamic: true
  });
  var tmpColor = new THREE.Color(0xBBBBBB);
  this.mesh = new THREE.Mesh(geometry, new THREE.StrippedLambertMaterial({
    color: tmpColor,
    emissive: tmpColor.multiplyScalar(this.emissiveness),
    smoothShading: true
  }));
  this.mesh.castShadow = true;
  this.mesh.receiveShadow = true;
  this.add(this.mesh);
  this.cubeTemplate = new THREE.BoxGeometry(1, 1, 1);
  for (var i = 0; i < this.cubeTemplate.faces.length; i++) {
    this.cubeTemplate.faces[i].materialIndex = 0;
  }
  this.cubeTemplate.faceVertexUvs = [[]];
  this.entities = [];
}
ExplosionManager.staticMatrix = new THREE.Matrix4();
ExplosionManager.prototype = Object.create(THREE.Object3D.prototype);
Object.defineProperty(ExplosionManager, "finished", function () {
  return this.entities.length === 0;
});
ExplosionManager.prototype.explodeAt = function (x, y, z, scaleMult) {
  this.sizeMin = 0.35 * scaleMult;
  this.sizeRange = 2.2 * scaleMult;
  this.velocityMin = 30 * scaleMult;
  this.velocityRange = 17 * scaleMult;
  tmpVector.set(x, y, z);
  for (var i = 0; i < this.largeSpawnCount; i++) {
    this.spawnEntity(Math.random() * 0.1 + 0.9, tmpVector, false);
  }
  for (var i = 0; i < this.smallSpawnCount; i++) {
    this.spawnEntity(Math.random() * 0.9, tmpVector, false);
  }
};
ExplosionManager.prototype.spawnEntity = function (rankSeed, position) {
  var rank = Math.pow(rankSeed, 2.5);
  var size = rank * this.sizeRange + this.sizeMin;
  var velocityScale = (1 - rank) * this.velocityRange + this.velocityMin;
  var velocity = this._randomVector().normalize().multiplyScalar(velocityScale);
  var lifeSpeed = rank * this.lifeSpeedRange + this.lifeSpeedMin;
  var index = 0;
  while (true) {
    var uniqueIndex = true;
    for (var i = 0; i < this.entities.length; i++) {
      var e = this.entities[i];
      if (e.index === index) {
        uniqueIndex = false;
        break;
      }
    }
    if (uniqueIndex) {
      break;
    } else {
      index++;
    }
  }
  if (index * 8 > this.mesh.geometry.vertices.length - 1) {
    this.mesh.geometry.merge(this.cubeTemplate, ExplosionManager.emptyMatrix);
  }
  this.entities.push({
    index: index,
    rank: rank,
    rankSeed: rankSeed,
    life: 0,
    lifeSpeed: lifeSpeed,
    size: size,
    position: position.clone(),
    velocity: velocity
  });
};
ExplosionManager.prototype.destroyEntity = function (entity) {
  this.entities.splice(this.entities.indexOf(entity), 1);
  for (var i = entity.index * 8; i < (entity.index + 1) * 8; i++) {
    this.mesh.geometry.vertices[i].set(0, 0, 0);
  }
  this.mesh.geometry.verticesNeedUpdate = true;
  this.mesh.geometry.elementsNeedUpdate = true;
  this._cleanGeometry();
};
ExplosionManager.prototype.update = function (dt) {
  dt /= 1000;
  for (var j = 0; j < this.entities.length; j++) {
    var entity = this.entities[j];
    entity.life += dt * entity.lifeSpeed;
    entity.velocity.multiplyScalar(1 - this.velocityDamping * dt);
    entity.position.add(entity.velocity.clone().multiplyScalar(dt));
    var scale = -Math.pow(entity.life / Math.sqrt(2), 2) + 2;
    scale *= entity.size;
    var vertCount = 8;
    for (var i = entity.index * vertCount; i < (entity.index + 1) * vertCount; i++) {
      var vert = this.mesh.geometry.vertices[i];
      var vertOffset = this.cubeTemplate.vertices[i % vertCount];
      vert.set(entity.position.x, entity.position.y, entity.position.z).addScaledVector(vertOffset, scale);
    }
    if (scale <= 0) {
      this.destroyEntity(entity);
    }
  }
  this.mesh.geometry.verticesNeedUpdate = true;
  this.mesh.geometry.elementsNeedUpdate = true;
  this.mesh.geometry.computeBoundingSphere();
};
ExplosionManager.prototype._cleanGeometry = function () {
  var verts = this.mesh.geometry.vertices;
  var faces = this.mesh.geometry.faces;
  var highestIndex = -1;
  for (var i = 0; i < this.entities.length; i++) {
    var e = this.entities[i];
    if (e.index > highestIndex) {
      highestIndex = e.index;
    }
  }
  var deleteIndex = highestIndex + 1;
  verts.splice(deleteIndex * 8, verts.length - deleteIndex * 8);
  faces.splice(deleteIndex * 12, faces.length - deleteIndex * 12);
};
ExplosionManager.prototype._randomVector = function () {
  return new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5);
};

// PHYS TYPES:
var physTypes = [{
  mat: THREE.MeshBasicMaterial,
  snd: {
    rng: 26,
    src: ["whizz_0", "whizz_1"],
    vol: 0.12
  },
  spd: 1.7,
  scale: 1.0,
  length: 13,
  color: 0xffffdb
}, {
  spd: [0.03, 0.031],
  rand: true,
  carryV: true,
  grav: 0.0003,
  spn: [0.04, 0.05],
  scale: 0.15,
  length: 0.5,
  color: 0x9a7b3e
}, {
  spd: [0.03, 0.031],
  rand: true,
  carryV: true,
  grav: 0.0003,
  spn: [0.03, 0.05],
  scale: 0.1,
  length: 0.4,
  color: 0x9a7b3e
}];

// PHYS OBJ:
function PhysObj(RENDER) {
  this.mesh = new THREE.Mesh(RENDER.cubeGeo);

  // INIT:
  this.init = function (x, y, z, xD, yD, dst, data, holder) {
    this.dst = dst;
    this.scale = data.scale;
    this.spd = data.spd[1] ? UTILS.randFloat(data.spd[0], data.spd[1]) : data.spd;
    var carryVel = data && data.carryV && holder;
    xD -= Math.PI;
    this.xS = this.spd * Math.sin(xD) * Math.cos(yD) + (carryVel ? holder.xVel : 0);
    this.zS = this.spd * Math.cos(xD) * Math.cos(yD) + (carryVel ? holder.zVel : 0);
    this.yS = this.spd * Math.sin(yD) + (carryVel ? holder.yVel : 0);
    this.grav = data.grav;
    this.spin = data.spn ? data.spn[1] ? UTILS.randFloat(data.spn[0], data.spn[1]) : data.spn : 0;
    this.mesh.receiveShadow = data.mat != THREE.MeshBasicMaterial;
    this.mesh.material = RENDER.getMat("default", {
      fog: data.mat != THREE.MeshBasicMaterial,
      color: data.color,
      emissive: data.emis,
      mat: data.mat
    });
    this.layer = holder && holder.isYou ? 1 : 0;
    this.sound = holder && holder.isYou ? null : data.snd;
    this.soundPlayed = false;
    this.mesh.layers.set(this.layer);
    RENDER.moveMesh(this.mesh, x, y, z);
    this.mesh.lookAt(x + this.xS, y + this.yS, z + this.zS);
    if (data && data.rand) {
      this.mesh.rotateX(UTILS.randFloat(-Math.PI, Math.PI));
    }
    RENDER.scaleMesh(this.mesh, data.scale, data.scale, data.length);
  };

  // CHECK SOUND:
  this.checkSound = function () {
    if (this.sound && !this.soundPlayed) {
      var tmpPos = Howler.pos();
      var tmpDst = UTILS.getDistance3D(tmpPos[0], tmpPos[1], tmpPos[2], this.mesh.position.x, this.mesh.position.y, this.mesh.position.z);
      if (tmpDst <= this.sound.rng) {
        SOUND.play(this.sound.src[UTILS.randInt(0, this.sound.src.length - 1)], this.sound.vol, false, UTILS.randFloat(0.8, 1.2));
        this.soundPlayed = true;
      }
    }
  };

  // UPDATE:
  this.update = function (delta) {
    if (this.mesh.visible) {
      this.mesh.position.x += this.xS * delta;
      this.mesh.position.z += this.zS * delta;
      this.mesh.position.y += this.yS * delta;
      if (this.spin) {
        this.mesh.rotateX(this.spin * delta);
      }
      this.yS -= (this.grav || 0) * delta;
      this.dst -= this.spd * delta;
      this.checkSound();
      if (this.dst <= 0) {
        this.mesh.visible = false;
      }
    }
  };
} // SPRITE OBJECT:
THREE.Sprite.prototype.init = function (x, y, z, xV, yV, zV, scale, life, grav, area) {
  this.position.x = x;
  this.position.y = y;
  this.position.z = z;
  this.xVel = xV;
  this.yVel = yV;
  this.zVel = zV;
  this.scale.x = this.scale.y = scale;
  this.life = life || 0;
  this.grav = grav || 0;
  this.area = area;
  this.updC = 0;
};
THREE.Sprite.prototype.update = function (delta) {
  if (this.visible) {
    this.position.x += this.xVel * delta;
    this.position.y += this.yVel * delta;
    this.yVel -= this.grav * delta;
    this.position.z += this.zVel * delta;
    if (this.area) {
      var tmpScl = this.scale.x / 2;
      if (this.position.x - tmpScl >= this.area.x + this.area.w) {
        this.position.x = this.area.x - this.area.w - tmpScl;
      } else {
        if (this.position.x + tmpScl <= this.area.x - this.area.w) {
          this.position.x = this.area.x + this.area.w + tmpScl;
        }
      }
      if (this.position.z - tmpScl >= this.area.z + this.area.l) {
        this.position.z = this.area.z - this.area.l - tmpScl;
      } else {
        if (this.position.z + tmpScl <= this.area.z - this.area.l) {
          this.position.z = this.area.z + this.area.l + tmpScl;
        }
      }
      if (this.position.y - tmpScl >= this.area.y + this.area.h) {
        this.position.y = this.area.y - tmpScl;
      } else {
        if (this.position.y + tmpScl <= this.area.y) {
          this.position.y = this.area.y + this.area.h + tmpScl;
        }
      }
    }
    if (this.life > 0) {
      this.life -= delta;
      if (this.life <= 0 && this.updC) {
        this.visible = false;
      }
      this.updC++;
    } else {
      if (this.life <= 0 && this.updC) {
        this.visible = false;
      }
    }
  }
};

// EFFECTS:
var rotations = [Math.PI / 3, -Math.PI / 3];
var effects = [{
  hole: true,
  count: 2,
  grav: -0.00002,
  scale: [5, 9],
  speed: [0, 0.025],
  spread: [-0.4, 0.4],
  life: [300, 500]
}, {}, {
  count: 1,
  blending: 2,
  scale: [5, 7],
  speed: [0, 0],
  spread: [0, 0],
  life: [30, 35]
}, {
  count: 1,
  blending: 2,
  scale: [2000, 2000],
  speed: [0, 0],
  spread: [0, 0]
}, {
  count: 4,
  src: "0",
  scale: [5, 6],
  speed: [0, 0.01],
  spread: [-1, 1],
  life: [600, 800]
}];

// PARTICLE MANAGER:
module.exports = function (RENDER, config) {
  // INIT:
  var tmpObj;
  var tmpParticle;
  var tmpTrail;
  this.particles = [];
  this.trails = [];
  this.physObjs = [];
  this.areas = [];
  this.active = true;
  this.ExplosionManager = new ExplosionManager();

  // PREFABS:
  this.prefabs = [{
    src: "glow_0",
    blending: 2,
    spd: 0.008,
    cnt: 2.2,
    grav: [-0.015, -0.005],
    scl: [0.7, 1],
    dir: 0
  }, {
    src: "glow_1",
    blending: 1,
    spd: 0.003,
    cnt: 8.0,
    grav: [-0.2, -0.22],
    scl: [1, 1.5],
    dir: 0
  }, {
    src: "fog_0",
    blending: 1,
    spd: 0.002,
    cnt: 6.0,
    grav: [0.0, 0.0],
    scl: [25, 30],
    dir: 0
  }];

  // ADD TRAIL:
  this.addTrail = function (parent) {
    tmpTrail = null;
    for (var i = 0; i < this.trails.length; ++i) {
      if (!this.trails[i].mesh.visible) {
        tmpTrail = this.trails[i];
        break;
      }
    }
    if (!tmpTrail) {
      tmpTrail = new Trail(RENDER);
      this.trails.push(tmpTrail);
      RENDER.scene.add(tmpTrail.mesh);
    }
    tmpTrail.init(parent);
  };

  // PARTICLE AREA:
  this.area = function (x, y, z, w, h, l, data, f) {
    w /= 2;
    l /= 2;
    this.areas.push({
      f: f,
      x: x,
      y: y,
      z: z,
      w: w,
      h: h,
      l: l
    });
    for (var i = 0; i < data.count; ++i) {
      this.add(data.src, x + UTILS.randInt(-w, w), y + UTILS.randInt(0, h), z + UTILS.randInt(-l, l), data.spd * Math.sin(data.dir), data.grav ? UTILS.randFloat(data.grav[0], data.grav[1]) : 0, data.spd * Math.cos(data.dir), UTILS.randFloat(data.scl[0], data.scl[1]), 0, 0, data.blending, this.areas[this.areas.length - 1]);
    }
  };

  // PARTICLE EFFECT:
  this.effect = function (x, y, z, xDir, yDir, effect) {
    if (!this.active || RENDER.useDepthMap != 0 && RENDER.useDepthMap != "0") {
      return;
    }
    tmpObj = effects[effect];
    for (var i = 0; i < tmpObj.count; ++i) {
      var tmpSpd = UTILS.randFloat(tmpObj.speed[0], tmpObj.speed[1]);
      var tmpX = xDir + UTILS.randFloat(tmpObj.spread[0], tmpObj.spread[1]);
      var tmpY = yDir + UTILS.randFloat(tmpObj.spread[0], tmpObj.spread[1]);
      this.add(effect, x, y, z, tmpSpd * Math.sin(tmpX) * Math.cos(tmpY), tmpSpd * Math.sin(tmpY), tmpSpd * Math.cos(tmpX) * Math.cos(tmpY), UTILS.randFloat(tmpObj.scale[0], tmpObj.scale[1]), tmpObj.life ? UTILS.randInt(tmpObj.life[0], tmpObj.life[1]) : 0, tmpObj.grav, tmpObj.blending, null, tmpObj.src);
    }
    if (tmpObj.hole) {
      this.add(1, x, y, z, 0, 0, 0, UTILS.randFloat(0.4, 1), 5000, 0, THREE.SubtractiveBlending);
    }
  };

  // SHOW PARTICLES:
  this.add = function (effect, x, y, z, xV, yV, zV, scale, life, grav, blending, area, src) {
    tmpParticle = null;
    for (var i = 0; i < this.particles.length; ++i) {
      if (!this.particles[i].visible && !this.particles[i].static) {
        tmpParticle = this.particles[i];
        break;
      }
    }
    if (!tmpParticle) {
      tmpParticle = new THREE.Sprite();
      this.particles.push(tmpParticle);
      RENDER.scene.add(tmpParticle);
    }
    this.setMaterial(tmpParticle, src || effect, blending, true);
    tmpParticle.visible = true;
    tmpParticle.init(x, y, z, xV, yV, zV, scale, life, grav, area);
  };

  // SET MATERIAL:
  this.setMaterial = function (particle, src, blending, rot) {
    particle.material = RENDER.getMat("particles/" + src, {
      mat: THREE.SpriteMaterial,
      depthWrite: false,
      blending: blending || THREE.NormalBlending,
      rotation: rot ? rotations[UTILS.randInt(0, 2)] : 0
    });
  };

  // ADD PHYS OBJ:
  this.physObj = function (x, y, z, xD, yD, dst, trail, indx, holder, dat, sid) {
    if (RENDER.useDepthMap != 0 && RENDER.useDepthMap != "0") {
      return;
    }
    tmpParticle = null;
    for (var i = 0; i < this.physObjs.length; ++i) {
      if (!this.physObjs[i].mesh.visible) {
        tmpParticle = this.physObjs[i];
        break;
      }
    }
    if (!tmpParticle) {
      tmpParticle = new PhysObj(RENDER);
      this.physObjs.push(tmpParticle);
      RENDER.scene.add(tmpParticle.mesh);
    }
    tmpParticle.sid = sid != undefined ? sid : null;
    tmpParticle.mesh.visible = true;
    tmpParticle.init(x, y, z, xD, yD, dst, dat || physTypes[indx], holder);
    if (trail && this.showTrails) {
      this.addTrail(tmpParticle);
    }
  };

  // DISABLE BY SID:
  this.disablePhys = function (sid) {
    for (var i = 0; i < this.physObjs.length; ++i) {
      if (this.physObjs[i].sid == sid) {
        this.physObjs[i].mesh.visible = false;
      }
    }
  };

  // UPDATE:
  this.update = function (delta, player) {
    if (player && player.active) {
      for (var i = 0; i < this.areas.length; ++i) {
        if (this.areas[i].f) {
          this.areas[i].x = player.x;
          this.areas[i].y = player.y;
          this.areas[i].z = player.z;
        }
      }
    }
    for (var i = 0; i < this.trails.length; ++i) {
      this.trails[i].update(delta);
    }
    for (var i = 0; i < this.particles.length; ++i) {
      this.particles[i].update(delta);
    }
    for (var i = 0; i < this.physObjs.length; ++i) {
      this.physObjs[i].update(delta);
    }
    this.ExplosionManager.update(delta);
  };

  // RESET:
  this.reset = function () {
    this.particles.length = 0;
    this.trails.length = 0;
    this.physObjs.length = 0;
    this.areas.length = 0;
  };
};